import { Loader, MessageSquareShare, X } from "lucide-react";
import React, { useRef, useState } from "react";
import Select from "react-select";
import Badge from "../UI/Badge";
import { countSegments, can_visit, usPhoneFormat } from "../../helpers";
import { getSMSLimitData, submitBulkMessage } from "../../services/message";
import { notify } from "../../helpers";
import { Drawer } from 'vaul';
import Spacing from "../Spacing";

export default function BulkMessageSendModal(props) {
  const { 
    checkedIds = [], 
    messageTemplate = [], 
    account_id, 
    location_id, 
    smsLimit = 0, 
    setSmsLimit = () => {},
    setGlobalCheckedIds,
    selectedPatientData,
    setSelectedPatientData = () => {}
  } = props;

  const [activeModal, setActiveModal] = useState(false);
  // const [selectedData, setSelectedData] = useState([]);
  const [selectedDataCount, setSelectedDataCount] = useState(0);
  const [segments, setSegments] = useState(0);
  const [requiredSms, setRequiredSms] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [messageBody, setMessageBody] = useState();
  const [chooseTemplate, setChooseTemplate] = useState(null);
  const dropdownRef = useRef(null);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const handleChange = (e) => {
    const value = e.target.value;
    setMessageBody(value);
    var totalSegment = countSegments(value);
    setSegments(totalSegment);
    setRequiredSms(totalSegment*selectedDataCount);
  };

  const sendBulkSms = () => {
    setActiveModal(true);
    // const GetSelectedData = getTableIdToContents("bulk", checkedIds);
    setSelectedDataCount(checkedIds.length);
    // setSelectedData(checkedIds);
    setRequiredSms(checkedIds.length*segments);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  };

  const getSMSLimit = async() => {
    const result = await getSMSLimitData(account_id);
    if (result) {
      setSmsLimit(result?.data);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(can_visit("_bulk_message")){
      setSubmitLoader(true);
      const notification_type = "Bulk";
      // const messageTransactions = selectedData.map((data) => ({
      //   notification_type: notification_type,
      //   message_body: messageBody
      //     .replace("[last_name]", data[0])
      //     .replace("[first_name]", data[1]),
      //   receiver_address: data[2],
      //   patient_id: data[3] ? parseInt(data[3], 10) : null,
      // }));
      const messageTransactions = selectedPatientData.map((patient) => ({
        notification_type: notification_type,
        patient_id: patient.id,
        message_body: messageBody
          .replace(/\[first_name\]/gi, patient.firstName || patient.full_name.split(" ")[1] || "")
          .replace(/\[last_name\]/gi, patient.lastName || patient.full_name.split(" ")[0] || ""),
        receiver_address: patient.mobilePhone || usPhoneFormat(patient?.mobile_phone),
      }));

      const response = await submitBulkMessage({
          message_transactions: messageTransactions,
        },
        account_id,
        location_id
      );

      if (response?.detail) {
        notify("error", response?.detail, 2);
        setSubmitLoader(false);
      } else { 
        if(response?.data?.status === 'success'){
          notify("success", messageTransactions.length +' '+ response?.data?.message, 2);
          setSelectedPatientData([]);
          setGlobalCheckedIds(new Set());
          handleDrawerClose();
          setTimeout(() => {
            getSMSLimit();
          }, 5000);
          setSubmitLoader(false);
        } else {
          notify("error", response?.data?.message, 2);
          setSubmitLoader(false);
        }
      }
    }
  };

  const copyText = (value) => {
    navigator.clipboard.writeText(value);
    // notify("success", "Copied "+value, 0.4)

    const messageTextarea = document.querySelector(
      'textarea[name="message_body"]'
    );
    const startPaste = messageTextarea.selectionStart;
    const endPaste = messageTextarea.selectionEnd;

    const newText =
      messageTextarea.value.substring(0, startPaste) +
      value +
      messageTextarea.value.substring(endPaste, messageTextarea.value.length);

    setMessageBody(newText);
    setSegments(countSegments(newText));
    setRequiredSms(countSegments(newText)*selectedDataCount);
  };

  const allMessageTemplate = messageTemplate?.map((option) => ({
    value: option?.id,
    label: option?.title,
  }));

  const handleTemplateChange = (selectedOption) => {
    const selectedTemplateId = selectedOption.value;
    setChooseTemplate(selectedTemplateId);
    const selectedTemplate = messageTemplate.find(
      (template) => template.id === parseInt(selectedTemplateId)
    );
    if (selectedTemplate) {
      setMessageBody(selectedTemplate.body);
      var totalSegment = countSegments(selectedTemplate.body);
      setSegments(totalSegment);
      setRequiredSms(totalSegment*selectedDataCount);
    }
  };

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={setActiveModal} onClose={handleDrawerClose}>
        <Drawer.Trigger 
          className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
          style={{ padding: '7px 12px' }}
          onClick={() => sendBulkSms()}
        >
          <MessageSquareShare width={20} height={20} />
          <span>Send Message</span>
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 large">
            <Drawer.Title className="sr-only">Bulk Message</Drawer.Title>
            <Drawer.Description className="sr-only">Send bulk message</Drawer.Description>
            <div className="docpro_modal_wrap docpro_modal_lg center">
              <div className="docpro_modal" style={{ backgroundColor: "#F9F9FB" }}>
                <button className="docpro_close_btn" onClick={() => {handleDrawerClose();}}>
                  <X />
                </button>
                <form onSubmit={handleSubmit}>
                  <h2 className="docpro_fs_24 docpro_mb_0">Send Bulk Messages</h2>
                  <Spacing lg="25" sm="25" />
                  <h6 className="docpro_indigo_color">
                    You have been selected for a total of{" "}
                    <b className="docpro_red_color">{selectedDataCount}</b> patients
                  </h6>
                  <>
                    <label className="docpro_fw_500 docpro_primary_color">
                      Message Template
                    </label>
                    <Select
                      options={allMessageTemplate}
                      placeholder="Search Template..."
                      isSearchable
                      value={allMessageTemplate?.find((option) => option?.value === chooseTemplate) || null}
                      onChange={handleTemplateChange}
                      className="react-select-container w-full"
                      classNamePrefix="react-select"
                      filterOption={(option, rawInput) => {
                        const words = rawInput.toLowerCase().split(" ");
                        return words.every((word) =>
                          option.label.toLowerCase().includes(word)
                        );
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '40px',
                          borderColor: 'var(--border)',
                          borderRadius: '8px'
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 1050,
                          marginTop: '-2px',
                          borderRadius: '0 0 3px 3px',
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 1050,
                          padding: 0
                        }),
                      }}
                    />
                    {/* <select
                      className="docpro_form_field size_lg"
                      onChange={handleTemplateChange}
                    >
                      <option value="">Select Template</option>
                      {messageTemplate?.map((template, index) => (
                        <option key={index} value={template.id}>
                          {template.title}
                        </option>
                      ))}
                    </select> */}
                    <Spacing lg="20" sm="20" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      Message Body <span className="docpro_red_color">*</span>{" "}
                      <span
                        className="docpro_badge docpro_badge_purple "
                        onClick={() => copyText("[first_name] ")}
                      >
                        [first_name]{" "}
                      </span>{" "}
                      <span
                        className="docpro_badge docpro_badge_purple "
                        onClick={() => copyText("[last_name] ")}
                      >
                        [last_name]{" "}
                      </span>
                    </label>
                    <textarea
                      required
                      minLength={2}
                      name="message_body"
                      className="docpro_form_field size_lg"
                      cols="30"
                      rows="7"
                      value={messageBody}
                      onChange={handleChange}
                      placeholder="Write your message here..."
                    ></textarea>
                    <Spacing lg="5" sm="5" />
                    <span className="docpro_primary_color docpro_fw_500">
                      Total segments{" "}
                      <Badge color="cyan" square>
                        {segments}
                      </Badge>
                    </span>
                  </>

                  <Spacing lg="12" sm="12" />
                  <hr />
                  <Spacing lg="15" sm="15" />
                  <div className="bulk_message_footer docpro_grid_gap_10">
                    <div>
                      <p className="docpro_mb_0">Available Message Credit: {smsLimit.available_credit}</p>
                      <p className="docpro_mb_0 flex items-center">
                        <span className="mr-2">
                          Required Message Credit: {requiredSms} 
                        </span>
                        {requiredSms > (smsLimit.available_credit) ? 
                          <button className="docpro_icon_btn overview" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                            <span className="docpro_red_color">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-alert"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>
                            </span>
                            <div className="docpro_tip">
                              <span>Insufficient credits</span>
                            </div>
                          </button>
                        : 
                          <span className="docpro_green_color">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shield-check"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>
                          </span>
                        }
                      </p>
                    </div>
                    {can_visit("_bulk_message") && (
                      <button
                        type="submit"
                        className="docpro_bordered_btn size_lg docpro_fw_600 docpro_white_color docpro_filed_btn docpro_mt_auto"
                        disabled={submitLoader ? true : false}
                      >
                        <span>Submit Now</span>
                      </button>
                    )}
                  </div>
                </form>
                {submitLoader && (
                  <span className="docpro_loading" style={{ backgroundColor: 'rgb(218 218 218 / 61%)' }}>
                    <Loader width={35} height={35} className="docpro_accent_color" />
                  </span>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
